import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService } from '../../../core';
import { ItemMarca } from '../item-marca';
import { ItemMarcaFilter } from '../filter/item-marca-filter';

@Injectable({
    providedIn: 'root'
})
export class ItemMarcaCrudHttpService implements Crud<ItemMarca> {
    resource = 'itemmarca';

    constructor(private crudService: CrudService) { }

    /** Pesquisa todas as marcas cadastradas */
    search(): Observable<ItemMarca[]> {
        return this.crudService.search<ItemMarca>(this.resource);
    }

    /** Pesquisa as marcas cadastradas aplicando o filtro informado */
    searchWithFilter(filter: ItemMarcaFilter): Observable<ItemMarca[]> {
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }
        return this.crudService.search<ItemMarca>(this.resource, { params });
    }

    /** Procura uma única marca através do seu ID */
    find(id: number): Observable<ItemMarca> {
        return this.crudService.find<ItemMarca>(this.resource, id);
    }

    /** Carrega uma única marca através do seu ID */
    load(id: number): Observable<ItemMarca> {
        return this.crudService.load<ItemMarca>(this.resource, id);
    }

    /** Insere uma nova marca */
    insert(entity: ItemMarca): Observable<ItemMarca> {
        return this.crudService.insert<ItemMarca>(this.resource, entity);
    }

    /** Altera uma marca existente */
    update(entity: ItemMarca): Observable<ItemMarca> {
        return this.crudService.update<ItemMarca>(this.resource, entity);
    }

    /** Exclui uma marca através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
